import type React from 'react'
import type { JSX } from 'react'

import { LabelFonts } from 'atoms/Label'
import {
  LabelInlinePrimaryTemplate,
  LabelWithBorderLeft,
} from 'atoms/Label/Templates'
import { OverlayLayoutColors } from 'atoms/OverlayLayout'
import { ProgressBarAccentTemplate } from 'atoms/ProgressBar/Templates'
import {
  TextBoxMaxLine1FontSmBold,
  TextBoxMaxLine1FontXs,
} from 'atoms/TextBox/Templates'
import { Colors, WordBreak } from 'atoms/TextBox/TextBox.h'
import {
  CARDS_ASPECT_RATIO,
  Card,
  CardCorners,
  CardDirection,
} from 'blocks/Cards'
import {
  TextBlock,
  TextBlockAlignItems,
  TextBlockRowGap,
} from 'blocks/TextBlock'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import {
  DescriptionBlockSC,
  TVShowCardWithDescriptionSC,
  timeLabelStyles,
} from './TVShowCardWithDescription.styled'
export interface ITVShowCardWithDescriptionProps {
  posterUrl?: string
  labelTitle?: string
  title?: string
  description?: string
  progress?: number
  width?: string
  posterAspectRatio?: (typeof CARDS_ASPECT_RATIO)[keyof typeof CARDS_ASPECT_RATIO]
  direction?: CardDirection
  isSelected: boolean
  posterWidth: string
  posterGradient?: OverlayLayoutColors
  paddings?: FIXED_INDENTS[]
  gap?: FIXED_INDENTS
  textBlockOffset?: FIXED_INDENTS[]
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  labelPrice?: string
  rented?: boolean
  paid?: boolean
  aclBlockedBy?: boolean
}

export const TVShowCardWithDescription = ({
  posterUrl,
  labelTitle,
  progress,
  width,
  title,
  description,
  direction = CardDirection.Horizontal,
  posterAspectRatio = CARDS_ASPECT_RATIO.HORIZONTAL_TV_SHOW_INNER_CARD,
  posterWidth,
  posterGradient = OverlayLayoutColors.EPISODE_CARD_VERTICAL_OVERLAY,
  isSelected = false,
  paddings = [FIXED_INDENTS.INDENT_30, FIXED_INDENTS.INDENT_60],
  gap = FIXED_INDENTS.INDENT_60,
  textBlockOffset,
  onClick,
  labelPrice,
  rented,
  paid,
  aclBlockedBy,
}: ITVShowCardWithDescriptionProps): JSX.Element => {
  return (
    <TVShowCardWithDescriptionSC
      data-arcana-button='true'
      direction={direction}
      width={width}
      posterWidth={posterWidth}
      posterAspectRatio={posterAspectRatio}
      isSelected={isSelected}
      paddings={paddings}
      gap={gap}
      onClick={onClick}
    >
      <Card
        posterUrl={posterUrl}
        width={posterWidth}
        aspectRatio={posterAspectRatio}
        overlayEnabled={true}
        overlayGradient={posterGradient}
        overlayOnHoverEnabled={false}
        corners={CardCorners.CORNERS_10}
        aclBlockedBy={aclBlockedBy}
      >
        <>
          {(paid || (rented && labelPrice)) && (
            <LabelWithBorderLeft
              title={rented ? labelPrice : ''}
              withIcon={!rented}
              font={LabelFonts.FontSm}
            />
          )}
          {labelTitle && (
            <LabelInlinePrimaryTemplate
              className={timeLabelStyles}
              title={labelTitle}
              font={LabelFonts.FontXs}
            />
          )}
          {progress && progress > 0 && (
            <ProgressBarAccentTemplate progress={progress} />
          )}
        </>
      </Card>
      <DescriptionBlockSC textPaddings={textBlockOffset}>
        <TextBlock
          rowGap={TextBlockRowGap.INDENT_0}
          alignItems={TextBlockAlignItems.FlexStart}
        >
          <TextBoxMaxLine1FontXs
            title={title}
            color={Colors.TEXT_ICON_SECONDARY}
            wordBreak={WordBreak.BreakAll}
          />
          <TextBoxMaxLine1FontSmBold
            title={description}
            wordBreak={WordBreak.BreakAll}
          />
        </TextBlock>
      </DescriptionBlockSC>
    </TVShowCardWithDescriptionSC>
  )
}
